import React from "react";
import { Navigate } from "react-router-dom";
import "../styles/global.css";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
console.log('token',token);
  return token ? children : <Navigate to="/dashboard" />;
};

export default PrivateRoute;
